<template>
  <card>
    <!-- Card header -->
    <h5 slot="header" class="h3 mb-0">
      <i class="fas fa-info"></i>
      Validierung
    </h5>

    <!-- Card body -->
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <data-row
          title="Kundendaten"
          icon="fas fa-users"
          editable="true"
        >
          <small>
offer.customer valid ? -> {{  customer_valid }} 
          </small>
        </data-row>
      </div>



            <div class="list-group-item">
        <data-row
          title="Fahrzeug"
          icon="fas fa-car"
          editable="true"
        >
          <small>
offer.car valid ? -> {{  car_valid }} 
          </small>
        </data-row>
      </div>

    </div>
 </card>
</template>
<script>
import { mapState } from "vuex";
import DataRow from "./elements/DataRow";
import moment from 'moment';
import offerUtil from "../../services/offer";

export default {
  name: "calc-info",
  components: {
    DataRow,
  },
  data() {
    return {};
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY h:mm")
    },
  },
  //console.log(offerUtil.all_ages_over_23(this.offer));
  computed: {
    ...mapState({
      offer: (state) => state.offer,
    }),
    customer_valid(){
      return offerUtil.customer_valid(this.offer);
    },
    car_valid(){
      return offerUtil.car_valid(this.offer);
    },
  },
};
</script>
<style>
</style>